module.exports = __webpack_public_path__ + "media/img/logos/hno-koeln-34e8f0aa5ab3ec4c444df13a38b55598.png";